import React from 'react';
export function TipIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 17.223c0-.741-.462-1.503-1.237-2.175a8 8 0 1110.474 0C16.462 15.72 16 16.482 16 17.223V19a3.001 3.001 0 01-2 2.83V22a1 1 0 01-1 1h-2a1 1 0 01-1-1v-.17A3.001 3.001 0 018 19v-1.777zM6 9a6 6 0 119.927 4.536c-.708.614-1.404 1.45-1.732 2.464h-4.39c-.328-1.015-1.024-1.85-1.732-2.464A5.984 5.984 0 016 9zm8 9v1a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1h4z"
  }));
}